import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./Auth/auth";
import Page from './Layout/Page';

function PrivateRoute({ component: Component, ...rest }) {
  const { token } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) =>
          token ? (
              <Page title={rest.title} token={rest.token}><Component {...props} /></Page>
          ) : (
              <Redirect to="/login" />
          )
      }
    />
  );
}

export default PrivateRoute;